import {defineStore} from 'pinia'
import {ref, watch} from 'vue'
import {debounce} from 'lodash'
import type {StudyMode} from '@shared/types'
import {ThemeMode, type ThemeMode as ThemeModeValue} from '@/lib/theme'

export const CardsFloatingControlSizes = [10, 12, 14, 15, 16, 18, 20] as const
export type CardsFloatingControlSize = (typeof CardsFloatingControlSizes)[number]

export const useLocalStore = defineStore(
  'local',
  () => {
    const profileId = ref<number>(NaN)

    // Translation view state
    const lastLevel = ref<number>(1)
    const lastUnit = ref<number>(1)
    const lastLesson = ref<number>(1)
    const lastTargetLang = ref<string>('en')
    const lastNativeLang = ref<string>('ru')
    const lastMaterialId = ref<number | null>(null)
    const studyAutoSpeak = ref<boolean>(true)
    const studyShuffle = ref<boolean>(false)
    const study3d = ref<boolean>(true)
    const studyRemembered = ref<Record<string, number[]>>({})
    const cardsAutoSpeak = ref<boolean>(true)
    const cardsShuffle = ref<boolean>(true)
    const cardsIs3d = ref<boolean>(true)
    const cardsEnableSwipe = ref<boolean>(true)
    const cardsHideNav = ref<boolean>(false)
    const cardsFloatingControls = ref<boolean>(false)
    const cardsFloatingControlsSize = ref<CardsFloatingControlSize>(15)
    const cardsShowImageOnFront = ref<boolean>(false)
    const cardsLevel = ref<number | null>(null)
    const cardsUnit = ref<number | null>(null)
    const cardsMode = ref<StudyMode>('listen')
    const theme = ref<ThemeModeValue>(ThemeMode.System)

    return {
      profileId,
      lastLevel,
      lastUnit,
      lastLesson,
      lastTargetLang,
      lastNativeLang,
      lastMaterialId,
      studyAutoSpeak,
      studyShuffle,
      study3d,
      studyRemembered,
      cardsAutoSpeak,
      cardsShuffle,
      cardsIs3d,
      cardsEnableSwipe,
      cardsHideNav,
      cardsFloatingControls,
      cardsFloatingControlsSize,
      cardsShowImageOnFront,
      cardsLevel,
      cardsUnit,
      cardsMode,
      theme,
    }
  },
  {
    // @ts-ignore
    persist: {
      storage: localStorage,
      // @ts-ignore
      paths: [
        'profileId',
        'lastLevel',
        'lastUnit',
        'lastLesson',
        'lastTargetLang',
        'lastNativeLang',
        'lastMaterialId',
        'studyAutoSpeak',
        'studyShuffle',
        'study3d',
        'studyRemembered',
        'cardsAutoSpeak',
        'cardsShuffle',
        'cardsIs3d',
        'cardsEnableSwipe',
        'cardsHideNav',
        'cardsFloatingControls',
        'cardsFloatingControlsSize',
        'cardsShowImageOnFront',
        'cardsLevel',
        'cardsUnit',
        'cardsMode',
        'theme',
      ],
    },
  }
)
